import React from "react";

function History() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div style={{ padding: '60px' }}>
              <h3 className="hheading">ക്ഷേത്രചരിത്രം</h3>
              <p className="hcontent">
                കൊടിമൂട്ടിൽ കുടുംബത്തിലെ കാരണവർ മണ്ടയ്ക്കാട്ട് ദേവിയുടെ ഉപാസകനായിരുന്നു. രണ്ട് നൂറ്റാണ്ടുകൾക്ക് മുമ്പ് അന്നത്തെ പുത്തൻവിള പുരയിടത്തിൽ കാട് വെട്ടിതെളിച്ച് കൊണ്ടിരുന്നപ്പോൾ രണ്ട് മൺപുറ്റുകൾ കാണുകയും അതിൽ നിന്നും രക്തം വാർന്ന് ഒഴുകുന്നത് കണ്ട് സംഭീതനായി കുടുംബാംഗങ്ങളോടൊപ്പം പ്രശ്‌നചിന്ത ചെയ്‌ത്‌  ദേവീസാന്നിദ്ധ്യം സ്ഥിരീകരിക്കുകയും ചെയ്തു. തുടർന്ന് മൺപുറ്റ് കണ്ട സ്ഥലത്ത് ആൽത്തറ കെട്ടി പുറ്റിൻമേൽ പൂജകൾ ചെയ്‌ത്‌ ദേവീപ്രീതി വരുത്തി. മണ്ടയ്ക്കാട്ട് ദേവിയുടെ ഉപാസകനായിരുന്ന കാരണവർ തുടർന്ന് മണ്ടയ്ക്കാട്ട് ദേവീ ദർശനത്തിനായി ഇരുമുടികെട്ടുമായി പരിവാരങ്ങളോടൊപ്പം യാത്രയായി. ആൽതറ സ്ഥാപിച്ചിരുന്ന സ്ഥലത്ത് പിൽക്കാലത്ത് ക്ഷേത്രം നിർമ്മിക്കുകയും കുടുംബകാരണവർ സ്വന്തം കൈകൊണ്ട് മെനഞ്ഞെടുത്ത ദേവിയുടെ കളി മൺ വിഗ്രഹം മൺപുറ്റുകൾക്ക് പിന്നിലായി പ്രതിഷ്‌ഠിക്കുകയും ചെയ്‌തു. തുടർന്ന് ആരാധനയും പൂജയും നടത്തി ദേവിയെ സംപ്രീതയാക്കി പോരുകയാണ്. ക്ഷേത്രത്തിലെ വാർഷിക ഉത്സവം മണ്ടയ്ക്കാട്ട് കൊടയുമായി ബന്ധപ്പെട്ടിരിക്കുന്നു. കുംഭമാസത്തിലെ നാലാമത്തെ ചൊവ്വാഴ്ച നടക്കുന്ന മണ്ടയ്ക്കാട്ട് കൊടയ്ക്ക് തൊട്ട് മുൻപിലുള്ള ഞായറാഴ്ച കൊടിമൂട്ടിൽ ക്ഷേത്രോത്സവം കഴിഞ്ഞ് കൊടിയിറക്കി തിങ്കളാഴ്‌ച വെളുപ്പിന് കൊടിമൂട്ടിൽ കാരണ വരും പരിവാരങ്ങളും മണ്ടയ്ക്കാട്ട് കൊടദർശനത്തിനായി പുറപ്പെടും. ഈ ആചാരം ഇന്നും അതുപോലെ പിൻതുടരുന്നു. 1991ൽ ദേവപ്രശ്‌നവിധി അനുസരിച്ച് ക്ഷേത്രത്തിൽ ജീർണ്ണോദ്ധാരണ പ്രവർത്തനങ്ങൾ നടത്തുകയും ശിലാവിഗ്രഹത്തിലേയ്ക്ക് ദേവീ ചൈതന്യം ആവാഹിക്കുകയും ചെയ്‌തു. തുടർന്ന് വൈദിക താന്ത്രിക വിധി പ്രകാരമുള്ള പൂജാദികർമ്മങ്ങൾ ആരംഭിച്ചു. കൊടിമൂട്ടിൽ കാരണവർക്ക് ദേവീചൈതന്യത്തെ പ്രത്യക്ഷപ്പെടുത്തിയ രണ്ട് മൺപുറ്റുകളും ഇപ്പോഴും വിഗ്രഹത്തിന് മുൻപിൽ സംരക്ഷിച്ച് പോരുന്നു.
              </p>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div className="col-md-6 about-frame" style={{ backgroundImage: 'url(./images/slider-1.png)', height: 'auto', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="about-right">
            {/* <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" /> */}
          </div>
        </div>
        <div class="col-md-6">
          <div style={{ padding: '60px' }}>
            <h3 className="hheading">കൊടിമൂട്ടിൽ നാമ ചരിത്രം</h3>
            <p className="hcontent">
              കൊടിമൂട്ടിൽ ക്ഷേത്ര ചരിത്രം കേരളത്തിൻ്റെ നവോത്ഥാന ചരിത്രവുമായി അഭേദ്യമായ ബന്ധമാണ് ഉള്ളത്. അധഃസ്ഥിതർക്കും ഈഴവരാദി പിന്നോക്ക വിഭാഗങ്ങൾക്കും ക്ഷേത്ര ആരാധനയ്ക്കും ക്ഷേത്രപ്രവേശനത്തിനും അനുവാദമില്ലാതിരുന്ന കാലത്ത് സവർണ്ണ മേധാവിത്വത്തെ വെല്ലുവിളിച്ചുകൊണ്ട് ക്ഷേത്ര ആരാധനയും ഉത്സവവും നടത്തിയ പാരമ്പര്യമാണ് കൊടിമൂട്ടിൽ ക്ഷേത്രത്തിനുള്ളത്. ഉത്സവം നടത്താൻ സവർണ്ണ മേധാവികൾ അനുവദിക്കാതിരുന്ന കാലത്ത് നാടിൻ്റെ വിവിധ കരങ്ങളിൽ കൊടിനാട്ടി കൊടിക്ക് ചുവട്ടിൽ മേളത്തോടെ ഉത്സവം നടത്തി വന്നിരുന്നു. ഒരു വർഷം ഉത്സവം നടത്തുന്ന സ്ഥലത്ത് അടുത്തവർഷം ഉത്സവം നടത്താൻ ജന്മിമാർ അനുവദിക്കുമായിരുന്നില്ല. അതിനാൽ ഓരോ വർഷവും ഓരോ കരയിൽ കൊടിനാട്ടി ഉത്സവം നടത്തി വരികയും പിന്നീട് മൺപുറ്റ് കണ്ട സ്ഥലത്ത് കൊടിമരം നാട്ടി അവിടെ സ്ഥിരമായി ഉത്സവം നടത്തുകയും ചെയ്‌തു. കൊടിയുടെ മൂട്ടിൽ ഉത്സവം നടത്തുന്ന സ്ഥലം എന്നതിൽ നിന്നാണ് കൊടിമൂട്ടിൽ എന്ന പേര് ഉത്ഭവിച്ചത്.
            </p>
          </div>
        </div>
      </div>
      <div class="row" >
        <div class="col-md-6">
          <div style={{ padding: '60px' }}>
            <h3 className="hheading">ക്ഷേത്രഭരണം</h3>
            <p className="hcontent">
              കൊടിമൂട്ടിൽ കുടുംബാംഗങ്ങളുടെ കുടുംബ പരദേവതയായ കൊടിമൂട്ടിൽ ശ്രീ ഭദ്ര കാളിയുടെ നാമധേയത്തിൽ രൂപം കൊണ്ടിട്ടുള്ള പാരിപ്പള്ളി കൊടിമൂട്ടിൽ ശ്രീ ഭദ്രകാളീക്ഷേത്ര യോഗം ട്രസ്റ്റ് ഒരു ഹിന്ദു ഡിനോമിനേഷണൽ പ്രൈവറ്റ് റിലിജിയസ് ചാരിറ്റബിൾ ട്രസ്റ്റാണ്. 1989ൽ ബഹു. കൊല്ലം സബ് കോടതി അനുവദിച്ച് ഉത്തരവായിട്ടുള്ള സ്‌കീം വ്യവസ്ഥ പ്രകാരണാണ് ട്രസ്റ്റ് പ്രവർത്തിച്ച് പോരുന്നത്. കൊടിമുട്ടിൽ കുടുംബത്തിലെ ഏറ്റവും മൂത്ത പുരുഷൻ മാനേജിംഗ് ട്രസ്റ്റിയും (പ്രസിഡൻ്റ്), തൊട്ടടുത്ത ഇളമുറക്കാരൻ വൈസ് പ്രസിഡന്റും കൊടിമൂട്ടിൽ കുടുംബാംഗങ്ങളിൽ നിന്നും തെരഞ്ഞെടുക്കപ്പെടുന്ന സെക്രട്ടറിയും ഉൾപ്പെടെ കൊടിമൂട്ടിൽ കുടുംബാംഗങ്ങളുടെ 9 അംഗ ഭരണസമിതിയാണ് ട്രസ്റ്റിൻ്റെ പ്രവർത്തനങ്ങളെ നിയന്ത്രിക്കുന്നത്.
            </p>
          </div>
        </div>
        <div className="col-md-6 about-frame" style={{ backgroundImage: 'url(./images/slider-1.png)', height: 'auto', backgroundSize: 'cover' }}>
          <div className="about-right">
            {/* <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" /> */}
          </div>
        </div>
      </div>
      <div class="row" >
        <div className="col-md-6 about-frame" style={{ backgroundImage: 'url(./images/slider-1.png)', height: 'auto', backgroundSize: 'cover' }}>
          <div className="about-right">
            {/* <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" /> */}
          </div>
        </div>
        <div class="col-md-6">
          <div style={{ padding: '60px' }}>
            <h3 className="hheading">ദമ്പതീഭാവത്തിലെ പനകൾ</h3>
            <p className="hcontent">
              കൊടിമൂട്ടിൽ ക്ഷേത്ര ഉല്‌പത്തിയെ സംബന്ധിച്ച് നിലനിൽക്കുന്ന ഐതിഹ്യത്തോളം പഴക്കമുള്ളതാണ് ക്ഷേത്രത്തിലെ കൊടിമരത്തിന് സമീപമായി വളർന്ന് നിൽക്കുന്ന രണ്ട് പനമരങ്ങൾ. ഇതിൽ ശ്രീ കോവിലിന് അഭിമുഖമായി ഇടതുഭാഗത്ത് പെൺ പനയും വലതുഭാഗത്ത് ആൺ പനയുമാണ് നിലകൊള്ളുന്നത്. ഏറെ വർഷങ്ങൾക്ക് ശേഷം പെൺ പനയുടെ ചുവട്ടിൽ പുതിയ കുട്ടിപ്പന വളർന്നു തുടങ്ങിയിരിക്കുന്നു. ദമ്പതി ഭാവത്തിൽ സ്ഥിതി ചെയ്യുന്ന ഈ പനകൾ ദേവിയുടെ മറ്റൊരു വരദാനമത്രേ. ഇവിടെ തൊഴുതു പ്രാർത്ഥിക്കുന്നവർക്ക് സന്താന സൗഭാഗ്യം ഉണ്ടാകുമെന്ന് നിരവധി അനുഭവസ്ഥർ സാക്ഷ്യപ്പെടുത്തുന്നു.
            </p>
          </div>
        </div>

      </div>
      <div class="row" >

        <div class="col-md-6">
          <div style={{ padding: '60px' }}>
            <h3 className="hheading">ചെമ്പകച്ചുവടും യക്ഷിപ്പനയും</h3>
            <p className="hcontent">
              ശ്രീ കോവിലിന്റെ ചുറ്റുമതിലിൻ്റെ ഇടതുഭാഗത്തായി വളർന്നുനിൽക്കുന്ന യക്ഷിപ്പന യക്ഷിയമ്മയുടെ വാസസ്ഥലമായി കരുതിക്കൊള്ളുന്നു. യക്ഷിയമ്മയ്ക്ക് യഥാവിധി മുറുക്കാൻ സമർപ്പിച്ച് സംപ്രീതയാക്കുന്ന പാരമ്പര്യം ഇന്നും തുടരുന്നു. ക്ഷേത്രത്തിലെ മൺപുറ്റുകളോളം പഴക്കമുള്ള ചെമ്പകമരം മറ്റൊരു ആകർഷണമാണ്. ദേവിക്ക് ആഭിമുഖമായി ചുറ്റമ്പലത്തിനു പുറത്ത് വളർന്നു നിൽക്കുന്ന അതിപുരാതനമായ ഈ ചെമ്പകം തറകെട്ടി സംരക്ഷിക്കുകയും ചെയ്തിട്ടുണ്ട്. ചെമ്പകച്ചുവട്ടിൽ പുജാപുഷ്‌പങ്ങളോ മറ്റു സമർപ്പണങ്ങളോ നടത്തരുതെന്നാണ് വൈദിക മതം. യക്ഷിക്കാവിനോട് ചേർന്ന് നാഗദേവതകൾക്ക് യഥാവിധി പൂജാദികർമ്മങ്ങൾ ചെയ്‌തു വരുന്നു. മകരമാസത്തിലെ ആയില്യത്തിന് വിശേഷാൽ പൂജകളും ക്ഷേത്ര തന്ത്രിയുടെ നേതൃത്വത്തിൽ വിപുലമായ സർപ്പബലി പൂജകളും നടത്തിവരുന്നു. എന്നാൽ നാഗദേവതകൾക്ക് ഇടവം, മിഥുനം, കർക്കടകം, ചിങ്ങം എന്നീ മാസങ്ങളിൽ വിശേഷാൽ പൂജകൾ ഒന്നും ഉണ്ടായിരിക്കുന്നതല്ല.
            </p>
          </div>
        </div>
        <div className="col-md-6 about-frame" style={{ backgroundImage: 'url(./images/slider-1.png)', height: 'auto', backgroundSize: 'cover' }}>
          <div className="about-right">
            {/* <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" /> */}
          </div>
        </div>

      </div>
      <div class="row" >
        <div className="col-md-6 about-frame" style={{ backgroundImage: 'url(./images/slider-1.png)', height: 'auto', backgroundSize: 'cover' }}>
          <div className="about-right">
            {/* <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" /> */}
          </div>
        </div>
        <div class="col-md-6">
          <div style={{ padding: '60px' }}>
            <h3 className="hheading">ശിവക്ഷേത്രം</h3>
            <p className="hcontent">
              വടക്ക് ദർശനമായി സ്ഥിതിചെയ്യുന്ന കൊടിമൂട്ടിൽ ദേവിക്ക്, വടക്കുകിഴക്ക് ഭാഗത്തായി പടിഞ്ഞാറ് ദർശനമുള്ള ശ്രീമഹാദേവൻ്റെ ആലയം സ്ഥിതി ചെയ്യുന്നു. വൈദിക വിധി അനുസരിച്ച് ശിവക്ഷേത്രം ജീർണ്ണോദ്ധാരണം നടത്തി ചുറ്റുമതിലോടു കൂടിയ ദേവാലയമാക്കി പുനപ്രതിഷ്‌ഠ ചടങ്ങുകൾ പൂർത്തീകരിച്ച് ആരാധന നടത്തിവരുന്നു. ശിവക്ഷേത്രത്തിന്റെ ചുറ്റുമതിലിന് പുറത്തായി മന്ത്രമൂർത്തിയുടെയും ബ്രഹ്മരക്ഷസിൻ്റെയും ആലയം സ്ഥിതി ചെയ്യുന്നു.
            </p>
          </div>
        </div>
      </div>
      <div className="container" style={{marginTop:'50px',marginBottom:'50px'}}>
        
          <div classname="col-md-12-">
            <img src="./images/1.png" alt="" style={{width:'100%'}} />
          </div>
          <div classname="col-md-12">
            <img src="./images/2.png" alt="" style={{width:'100%'}}  />
          </div>
        


      </div>
    </div>
  );
}

export default History;
